import styled from 'styled-components';
import { Panel, SectionLabel } from '@/ui';
import type { Community } from '@/core/models/community';

const List = styled.ol`margin: 0; padding-left: 18px; display: flex; flex-direction: column; gap: 8px;`;
const Item = styled.li`font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textMuted};`;

export function CommunityRulesPanel({ community }: { community: Community }) {
  return (
    <Panel>
      <SectionLabel as="h2">Community Rules</SectionLabel>
      <List>{community.rules.map((r) => <Item key={r}>{r}</Item>)}</List>
    </Panel>
  );
}
